import { toast } from "react-toastify";
import API from "../../helpers/api/api_interceptor";
import { SET_FILES_DATA, SET_MULTIMEDIA_DATA } from "./actionTypes";

const handleDocumentsFormDataAppend = (payload) => {
  const formData = new FormData();

  payload.forEach((obj, index) => {
    formData.append(`file-${index}`, obj.file);
    formData.append(`file_type-${index}`, obj.file_type);
    formData.append(`language_type-${index}`, obj.language_type);
    formData.append(`page_type-${index}`, obj.page_type);
    formData.append(`save_type-${index}`, obj.save_type);
  });

  return formData;
};

// to set the redux state for my veritas
const handleGetWebsiteDataLanguageWise = (websiteData) => {
  const data = { en: {}, pt: {} };
  websiteData?.forEach((item) => {
    data[item?.language_type][item?.file_type] = item?.file;
  });

  return data;
};

// to get the my-veritas page data
export const getWebsiteDocuments = (params) => async (dispatch) => {
  try {
    return API.get(`/website-management/data`, { params: { ...params } }).then((res) => {
      if (res && res.status && res.status === 200) {
        const data = handleGetWebsiteDataLanguageWise(res?.data?.data?.results);

        dispatch({
          type: SET_FILES_DATA,
          payload: data,
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// to upload myveritas images
export const uploadWebsiteDocuments = (payload) => async (dispatch) => {
  try {
    const formData = handleDocumentsFormDataAppend(payload);
    return API.post(`/website-management/data`, formData).then((res) => {
      if (res && res.status && res.status === 200) {
        toast.success(res?.data?.detail);
        const data = handleGetWebsiteDataLanguageWise(res?.data?.data);

        dispatch({
          type: SET_FILES_DATA,
          payload: data,
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// to get the list of multimedia
export const getMultimedia = (params) => async (dispatch) => {
  try {
    return API.get(`/website-management/multimedia`).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: SET_MULTIMEDIA_DATA,
          payload: {
            data: res?.data?.data?.results,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

const handleFormDataAppend = (payload) => {
  const formData = new FormData();

  for (var key in payload) {
    if (key === "files") {
      payload?.files?.forEach((item) => {
        formData.append("files", item);
      });
    }
  }

  return formData;
};

// to upload multimedia
export const uploadMultimedia = (payload) => async (dispatch) => {
  try {
    const formData = handleFormDataAppend(payload);
    return API.post(`/website-management/multimedia`, formData).then((res) => {
      if (res && res.status && res.status === 200) {
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// to delete multimedia
export const deleteMultimedia = (payload) => async (dispatch) => {
  try {
    return API.delete(`/website-management/multimedia`, {
      data: { ...payload },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};
